import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressBar from "./ProgressBar";
import axios from "axios";
import "./About.css";
import icon from "../images/cutegirl.png";

const About = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Access the location object

  const [inputs, setInputs] = useState(() => {
    return location.state || {};
  });

  const [countries, setCountries] = useState([]);
  const [errors, setErrors] = useState({});
  const [isDropdownFocused, setIsDropdownFocused] = useState(false); // Track focus state
  const [selectedCountry, setSelectedCountry] = useState(null);
// useEffect hook to fetch country data when the component mounts
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        // Making a GET request to the REST countries API to retrieve all countries
        const response = await axios.get("https://restcountries.com/v3.1/all?fields=name,cca2");
        // Mapping the response data to create an array of country options
        const countryOptions = response.data.map((country) => ({
          label: country.name.common,// Using the common name of the country as the label
          value: country.cca2,// Using the country code as the value
        }));

        // Defining a list of preferred countries to display first
        const preferredCountries = [
          "Australia",
          "United States",
          "United Kingdom",
          "France",
          "Singapore",
          "China",
          "Malaysia",
        ];

        // Finding the preferred countries from the fetched options
        const sortedPreferredCountries = preferredCountries
          .map((name) =>
            countryOptions.find((country) => country.label === name)// Find country option by name
          )
          .filter(Boolean);// Filter out any undefined values (in case any preferred country is not found)

        // Filtering out countries that are not in the preferred list and sorting them alphabetically
          const otherCountries = countryOptions
          .filter((country) => !preferredCountries.includes(country.label))// Exclude preferred countries
          .sort((a, b) => a.label.localeCompare(b.label));// Sort remaining countries by label

          // Updating the state with a combination of sorted preferred countries and other countries
        setCountries([...sortedPreferredCountries, ...otherCountries]);
      } catch (error) {
        // Logging an error message in case the API request fails
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);
// Function to handle input changes from form fields
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    // Updating the input values in state
    setInputs((prevInputs) => ({ ...prevInputs, [name]: value }));
// Validating firstname and lastname fields
    if (name === "firstname" || name === "lastname") {
      // Check if the value is not empty and matches the regex for 1-32 letters
      if (value && !/^[a-zA-Z]{1,32}$/.test(value)) {
        // If validation fails, set the name error in state
        setErrors((prevErrors) => ({
          ...prevErrors,
          nameError: "Name must be 1-32 characters and contain only letters.",
        }));
      } else {
        // If validation passes, remove the name error from state
        setErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          delete newErrors.nameError;
          return newErrors;
        });
      }
    }
  };

  const handleSelectChange = (selectedOption) => {
    setInputs((prevInputs) => ({ ...prevInputs, country: selectedOption }));
    setSelectedCountry(selectedOption);
    setIsDropdownFocused(false); // Remove focus state when an option is selected

    if (!selectedOption) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        country: "Country is required",
      }));
    } else {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors.country;
        return newErrors;
      });
    }
  };

  const handleNextClick = async () => {
    const { firstname, lastname, country } = inputs;
    const newErrors = {};

    if (!firstname && !lastname) {
      newErrors.nameError =
        "Please provide at least one name (firstname or lastname).";
    } else if (
      (firstname && !/^[a-zA-Z]{1,32}$/.test(firstname)) ||
      (lastname && !/^[a-zA-Z]{1,32}$/.test(lastname))
    ) {
      newErrors.nameError =
        "Name must be 1-32 characters and contain only letters.";
    }

    if (!country) {
      newErrors.country = "Country is required";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      navigate("/User", { state: { ...inputs } });
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(inputs);
  };

  const handleBackClick = () => {
    navigate("/", { state: { ...inputs } });
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: isDropdownFocused || selectedCountry ? 'rgba(224, 98, 109, 0.893)' : '#dee2e6',
      boxShadow: state.isFocused ? '0 0 0 1px rgba(224, 98, 109, 0.893)' : provided.boxShadow,
      '&:hover': {
        borderColor: 'rgba(224, 98, 109, 0.893)',
      },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // Ensure the dropdown menu is on top of other elements
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? 'rgba(224, 98, 109, 0.893)' : 'white', // Updated background color when focused
      color: state.isFocused ? 'white' : 'black', // White text when focused
      cursor: 'pointer',
      '&:active': {
        backgroundColor: 'rgba(224, 98, 109, 0.893)', // Ensure background color remains when option is selected
        color: 'white',
      },
    }),
  };

  return (
    <div className="about-container">
      <div className="about-box">
        <ProgressBar steps={3} currentStep={1} comboType="combo1" />
        <img src={icon} alt="cute_girl.jpg" className="signup-icon" />
        <p className="h4 fw-bold my-4">Create account</p>
        <p>Oh, you're new here! Tell us more.</p>
        <form onSubmit={handleSubmit}>
          <div className="">
            <div className="mb-2">
              <input
                type="email"
                placeholder="Enter your email"
                name="email"
                value={inputs.email || ""}
                onChange={handleInputChange}
                className="form-control w-100"
                required
                readOnly
              />
            </div>
            <div className="mb-2">
              <input
                type="text"
                placeholder="Enter your first name"
                name="firstname"
                value={inputs.firstname || ""}
                onChange={handleInputChange}
                className="form-control w-100"
              />
            </div>
            <div className="mb-2">
              <input
                type="text"
                placeholder="Enter your last name"
                name="lastname"
                value={inputs.lastname || ""}
                onChange={handleInputChange}
                className="form-control w-100"
              />
            </div>
            <div className="mb-2">
              <Select
                options={countries}
                placeholder="Select country"
                className="country-input"
                value={inputs.country}
                onChange={handleSelectChange}
                onFocus={() => setIsDropdownFocused(true)} // Set focus state to true on focus
                onBlur={() => setIsDropdownFocused(false)} // Set focus state to false on blur
                styles={customStyles}
                required
              />

              {errors.nameError && (
                <p className="error-message-about">{errors.nameError}</p>
              )}
              {errors.country && (
                <p className="error-message-about">{errors.country}</p>
              )}
            </div>

            <div className="row my-4 gx-2">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-light-gray w-75"
                  onClick={handleBackClick}
                >
                  Go Back
                </button>
              </div>
              <div className="col">
                <button
                  type="button"
                  className="btn btn-primary text-white w-75"
                  onClick={handleNextClick}
                >
                  Next
                </button>
              </div>
            </div>

            <div className="button-container"></div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default About;
